import React from "react";
import { AlertCircle } from "lucide-react";

// Discreet, non-alarming banner shown ONLY on the /legal page while at least
// one placeholder value remains. Rendered inside <LegalLayout showPreviewBanner>.
// Design: soft amber, subtle border, small icon. NOT red — red is reserved for
// destructive actions in the app (deletion).
export function LegalPreviewBanner() {
  return (
    <div
      role="note"
      data-testid="legal-preview-banner"
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: 10,
        padding: "12px 14px",
        marginBottom: 22,
        borderRadius: 12,
        background: "rgba(234, 179, 8, 0.10)",
        border: "1px solid rgba(234, 179, 8, 0.35)",
        color: "#8a5a06",
        fontSize: 13,
        lineHeight: 1.5,
      }}
    >
      <span style={{ marginTop: 1 }}><AlertCircle size={16} /></span>
      <span>
        Informations légales à compléter avant publication.
      </span>
    </div>
  );
}
